<script>
import moment from 'moment';
import axios from "axios";

const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

const COLUMN_DATA = [
  {
    title: 'Name',
    dataIndex: 'name',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Payment Date',
    dataIndex: 'payment_date',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Payment Id',
    dataIndex: 'payment_id',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Subscription Id',
    dataIndex: 'subscription_id',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    class: 'font-semibold text-muted',
  },
];

const JSON_FIELD = {
  'Name': 'name',
  'Phone': 'phone',
  'Payment Date': 'payment_date',
  'Payment Id': 'payment_id',
  'Subscription Id': 'subscription_id',
  'Amount': 'amount',
}

const JSON_META = [
  [
    {
      'key': 'charset',
      'value': 'utf-8'
    }
  ]
]

export default {
  name: "BkashUserPaymentHistory",
  data() {
    return {
      current_date: '',
      columnData: COLUMN_DATA,
      jsonFields: JSON_FIELD,
      jsonPaymentReportData: [],
      json_meta: JSON_META,
      confirmLoading: false,
      paymentHistory: [],
      paymentHistoryData: [],
    }
  },
  created() {
    this.current_date = moment().format('YYYY-MM-DD');
    this.getDatedReport();
  },
  methods: {
    onDateChange() {
      this.getDatedReport();
    },
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    getDatedReport() {
      this.confirmLoading = true;
      axios({
        method: 'get',
        url: `${ADMIN_URL}/bkash-user-report`,
        params: {
          date: moment(this.current_date).format('YYYY-MM-DD')
        }
      })
          .then(response => {
            this.confirmLoading = false;
            this.paymentHistory = response.data.data;
            this.paymentHistoryData = Object.entries(this.paymentHistory).map(function (history, label) {
              return {
                key: label + 1,
                name: history[1].name,
                phone: history[1].phone,
                payment_date: history[1].payment_date,
                payment_id: history[1].payment_id,
                subscription_id: history[1].subscription_id,
                amount: history[1].amount,
              };
            });
            this.jsonPaymentReportData = [];
          })
          .catch(e => {
            console.log("error occurs",e);
          });
    },
    loadRevenueData(history) {
      this.jsonPaymentReportData.push({
        'name': history.name,
        'phone': history.phone,
        'payment_date': history.payment_date,
        'payment_id': history.payment_id,
        'subscription_id': history.subscription_id,
        'amount': history.amount,
      })
    }
  },
  computed: {
    paymentHistoryList: function () {
      Object.entries(this.paymentHistory).map(history => {
        this.loadRevenueData(history[1])
      });
      return this.paymentHistoryData;
    }
  }
}
</script>

<template>
  <div>
    <a-row :gutter="24" type="flex">

      <!-- Projects Table Column -->
      <a-col :span="24" class="mb-24">

        <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
          <template #title>
            <a-row type="flex" align="middle">
              <a-col :span="24" :md="12" class="top-left-header">
                <h5 class="font-semibold m-0">User Bkash Payment History
                  <a-spin v-if="confirmLoading"/>
                </h5>
              </a-col>
              <a-col :span="24" :md="12" class="top-right-header">
                <a-button class="mr-2">
                  <export-excel
                      :data="jsonPaymentReportData"
                      :fields="jsonFields"
                      worksheet="My Worksheet"
                      :name="current_date + '.xls'">
                    Export
                  </export-excel>
                </a-button>
                <a-date-picker v-model="current_date" @change="onDateChange" :disabled-date="disabledDate"/>
              </a-col>
            </a-row>
          </template>
          <a-table :columns="columnData"
                   :data-source="paymentHistoryList"
                   :pagination="false"
                   :scroll="{x: true}">

            <template slot="name" slot-scope="text">
              <a>{{ text }}</a>
            </template>
          </a-table>
        </a-card>

      </a-col>
      <!-- / Projects Table Column -->

    </a-row>
  </div>
</template>

<style scoped>

</style>
